import { StrictLocalizeFunction } from "@faire/web/common/localization";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import { ITestimonialsData } from "@faire/retailer/components/TestimonialsCardSection/TestinomialsData";

export const FAIRE_BELONGING_EMPLOYEES = (
  strictLocalize: StrictLocalizeFunction
): readonly ITestimonialsData[] =>
  [
    {
      text: strictLocalize({
        defaultMessage:
          "“I’ve been overjoyed by how Faire celebrates diversity. To empower our entrepreneurs, we need to " +
          "understand how their diverse experiences play a role in their entrepreneurial journeys. I had the " +
          "honor of hosting a company-wide panel with some of our LGBTQ+ customers, where they shared how their " +
          "LGBTQ+ experiences inform the way they run their businesses and how Faire can help along the way. Faire " +
          "consistently strives to amplify the voices of both our customers and employees.”",
        description: {
          text: "Employee testimonial for the careers belonging at Faire page",
        },
      }),
      name: "Ben Dreier",
      info: (
        <StrictLocalMsg
          description={{ text: "Job title" }}
          defaultMessage="Director of Product"
        />
      ),
      imageUrl:
        "https://cdn.faire.com/fastly/ae983ade938c69d4688ad584788fd62bceafd06ffe5c788ae2266bda7d7e5773.png",
    },
  ] as const;
